import React from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  size?: "sm" | "md";
  color?: "primary" | "accent";
}

export function Toggle({
  checked,
  onChange,
  disabled,
  label,
  size = "md",
  color = "primary",
}: ToggleProps) {
  const trackSize = size === "sm" ? "w-7 h-4" : "w-9 h-5";
  const thumbSize = size === "sm" ? "w-3 h-3" : "w-4 h-4";
  const translate = size === "sm" ? "translate-x-3" : "translate-x-4";
  const colorVar = color === "accent" ? "var(--c-accent)" : "var(--c-primary)";
  return (
    <label className="inline-flex items-center gap-2.5 cursor-pointer">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative ${trackSize} rounded-full transition-all duration-300 ease-out focus:outline-none focus-visible:ring-1 focus-visible:ring-[var(--c-primary)] disabled:opacity-40`}
        style={{
          backgroundColor: checked ? colorVar : "var(--c-toggle-off)",
        }}
      >
        <span
          className={`absolute top-0.5 left-0.5 ${thumbSize} bg-white rounded-full shadow-sm transition-transform duration-300 ease-out ${
            checked ? translate : "translate-x-0"
          }`}
        />
      </button>
      {label && (
        <span className="text-sm" style={{ color: "var(--c-text-secondary)" }}>
          {label}
        </span>
      )}
    </label>
  );
}
